import styled from 'styled-components';

const BtnContainer = styled.div`
border-top: 1px solid var(--lineGray);
padding: 0.5rem 0.8rem;

.btn-add-to-cart {
  margin-left: 0.3rem;
}
.btn-back-to-product {
  margin-right: 0.3rem
}
`;

export default BtnContainer;